module.exports = __webpack_public_path__ + "img/rca-logo-black.5a53ab0f.svg";